import { ReplyOrder } from '@diritto/common/reply/constants';
import { useQueryClient } from '@tanstack/react-query';
import { repliesQueryKey } from 'queries/reply/queryKey';
import { useCallback } from 'react';

export const useInvalidateEpisodeReplyQueries = ({
  episodeId,
  contentId,
  profileId,
  replyId,
}: {
  contentId?: number;
  episodeId?: number;
  profileId?: number;
  replyId?: number;
}) => {
  const queryClient = useQueryClient();

  return useCallback(() => {
    if (episodeId) {
      queryClient.removeQueries({ queryKey: repliesQueryKey.episodeReplyList(episodeId, ReplyOrder.Like) });
      queryClient.removeQueries({ queryKey: repliesQueryKey.episodeReplyList(episodeId, ReplyOrder.Latest) });
    }

    if (profileId) {
      queryClient.removeQueries({ queryKey: repliesQueryKey.profileReplyList(profileId, ReplyOrder.Like) });
      queryClient.removeQueries({ queryKey: repliesQueryKey.profileReplyList(profileId, ReplyOrder.Latest) });
      queryClient.removeQueries({ queryKey: repliesQueryKey.profileReplyCount(profileId) });
    }

    if (contentId) {
      queryClient.removeQueries({ queryKey: repliesQueryKey.contentReplyRoot(contentId) });
    }

    if (replyId) {
      queryClient.removeQueries({ queryKey: repliesQueryKey.reply(replyId) });
      queryClient.removeQueries({ queryKey: repliesQueryKey.reReply(replyId, ReplyOrder.Created) });
      queryClient.removeQueries({ queryKey: repliesQueryKey.reReply(replyId, ReplyOrder.Like) });
      queryClient.removeQueries({ queryKey: repliesQueryKey.reReply(replyId, ReplyOrder.Latest) });
    }
  }, [contentId, episodeId, profileId, queryClient, replyId]);
};
